import { Text } from '@artprov/design-system'
import { formatearCuit } from './formatearCuit.js'
import { TEXTOS } from '../constants/textos.js'

const SIN_DATO = '-'

// Figma: el contenido de todas las columnas usa tertiary_10 (#262626).
// La columna de la acción queda afuera: es un link y lleva su propio color.
const textoCelda = (valor) => (
  <Text variant="body2" className="text-tertiary-10 truncate">
    {valor ?? SIN_DATO}
  </Text>
)

/**
 * Arma las filas de la grilla de selección de cuenta.
 *
 * La cuenta con la que el usuario está logueado se resalta y su acción queda
 * deshabilitada (criterio 6): no tiene sentido ingresar a donde ya se está.
 *
 * @param {Array} cuentas - ya ordenadas y filtradas
 * @param {Object} opciones
 * @param {number|string|null} opciones.contratoActivo
 * @param {number|null} opciones.contratoIngresando - contrato cuyo ingreso está en curso
 * @param {boolean} opciones.ingresoEnCurso - hay un cambio de cuenta en vuelo
 * @param {(cuenta: Object) => void} opciones.onIngresar
 */
export function buildCuentasSeleccionRows(
  cuentas,
  { contratoActivo, contratoIngresando = null, ingresoEnCurso = false, onIngresar } = {}
) {
  if (!Array.isArray(cuentas)) return []

  const activo = contratoActivo == null || contratoActivo === '' ? null : Number(contratoActivo)

  return cuentas.map((cuenta) => {
    const contrato = Number(cuenta?.contrato)
    const esActiva = activo !== null && contrato === activo
    const esLaQueIngresa = contratoIngresando !== null && contrato === Number(contratoIngresando)

    // Mientras hay un ingreso en curso se bloquea toda la grilla: dos POST
    // concurrentes actualizarían la misma sesión.
    const deshabilitado = esActiva || ingresoEnCurso

    return {
      id: cuenta?.contrato,
      rowClassName: esActiva ? 'bg-primary-95' : undefined,

      RAZON_SOCIAL: textoCelda(cuenta?.razonSocial),
      CUIT: textoCelda(formatearCuit(cuenta?.cuit)),
      CONTRATO: textoCelda(cuenta?.contrato),
      POLIZA: textoCelda(cuenta?.poliza),

      // Figma: Link/link3_encodesans — 12px, 600, 0.5px, subrayado, primary_30.
      // `typography-Link-XS` es esa tipografía en el design system; se aplica al
      // botón en vez de usar <Text variant="link3"> porque ese variant renderiza
      // un <a> y acá es una acción, no navegación.
      ACCION: (
        <button
          type="button"
          onClick={() => onIngresar?.(cuenta)}
          disabled={deshabilitado}
          aria-label={`${TEXTOS.INGRESAR} a ${cuenta?.razonSocial ?? ''}`.trim()}
          className={`typography-Link-XS ${deshabilitado ? 'text-tertiary-60 cursor-not-allowed' : 'text-primary-30'}`}
        >
          {esLaQueIngresa ? TEXTOS.INGRESANDO : TEXTOS.INGRESAR}
        </button>
      ),
    }
  })
}
